import CnpjFilter from './CnpjFilter';
import CpfFilter from './CpfFilter';

export default function DocumentFilter(document) {
  if (!document) return document;
  if (String(document).length === 11) {
    return CpfFilter(document);
  }
  return CnpjFilter(document);
}
